import { debugError } from "@/core/utils/print-utilts";
import { getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

export const FIREBASE_ID_TOKEN_HEADER = "X-Firebase-Id-Token";

/**
 * Header that proves the signed-in user's identity to Flair's HTTP GPU functions (inpaint, outpaint, upscale,
 * captions, custom-model post-processing). Those functions no longer trust the `UserId` header on its own.
 * Returns no header when nobody is signed in or the token can't be fetched; the function then refuses the call.
 */
export async function getFirebaseIdTokenHeader(
  expectedUserId?: string,
): Promise<Record<string, string>> {
  try {
    if (getApps().length === 0) {
      return {};
    }
    const currentUser = getAuth().currentUser;
    if (expectedUserId && currentUser?.uid !== expectedUserId) {
      return {};
    }
    const token = await currentUser?.getIdToken();
    return token ? { [FIREBASE_ID_TOKEN_HEADER]: token } : {};
  } catch (error) {
    debugError("Cannot get the Firebase ID token: ", error);
    return {};
  }
}
